import React, {useContext} from 'react'
import PropTypes from 'prop-types'
import NoticeTextInput from "components/complex/nationalNotice/components/inputs/NoticeTextInput";
import NoticeGlossaryInput from "components/complex/nationalNotice/components/inputs/NoticeGlossaryInput";
import NoticeCpvInput from "components/complex/nationalNotice/components/inputs/NoticeCpvInput";
import NoticeNumericInput from "components/complex/nationalNotice/components/inputs/NoticeNumericInput";
import NoticeIntegerInput from "components/complex/nationalNotice/components/inputs/NoticeIntegerInput";
import NoticeYesNoInput from "components/complex/nationalNotice/components/inputs/NoticeYesNoInput";
import FormTranslationContext from "context/FormTranslationContext";
import annulaReportClasses from "../../constants/annulaReportClasses";

function AnnualReportAboveEuEditForm(
    {
        entry,
        newEntry,
        buttonWorks,
        reportStep,
        formikProps
    }) {
    const {getDict} = useContext(FormTranslationContext)
    const classes = annulaReportClasses();
    return (<>
            <NoticeGlossaryInput
                label={`mmia.${reportStep}.type`}
                id="type"
                formikProps={formikProps}
                items={getDict("MP.MMiA.OrdersType")}
                disabled={buttonWorks.anyWorks}
            />
            <NoticeTextInput
                label={`mmia.${reportStep}.number`}
                id="number"
                formikProps={formikProps}
                disabled={buttonWorks.anyWorks || entry.demandId != null}
            />
            <NoticeTextInput
                label={`mmia.${reportStep}.noticeNumber`}
                id="noticeNumber"
                formikProps={formikProps}
                disabled={buttonWorks.anyWorks}
            />
            <NoticeGlossaryInput
                label={`mmia.${reportStep}.orderType`}
                id="orderType"
                formikProps={formikProps}
                items={getDict("ENUM.002")}
                disabled={buttonWorks.anyWorks}
            />
            <NoticeCpvInput
                label={`mmia.${reportStep}.codeCPV`}
                id="codeCPV"
                formikProps={formikProps}
                disabled={buttonWorks.anyWorks}
            />
            <NoticeGlossaryInput
                className={classes.exceptionChip}
                label={`mmia.${reportStep}.tenderMode`}
                id="tenderMode"
                formikProps={formikProps}
                items={getDict("ENUM.018_019_TED")}
                disabled={buttonWorks.anyWorks}
            />
            <NoticeGlossaryInput
                label={`mmia.${reportStep}.contractorCountryList`}
                id="contractorCountryList"
                formikProps={formikProps}
                items={getDict("SL.MT.005")}
                prefixLabelsWithKeys
                multiple
                disabled={buttonWorks.anyWorks}
            />
            <NoticeNumericInput
                label={`mmia.${reportStep}.contractValue`}
                id="contractValue"
                formikProps={formikProps}
                disabled={buttonWorks.anyWorks}
            />
            <NoticeIntegerInput
                label={`mmia.${reportStep}.numberOfAwardedLots`}
                id="numberOfAwardedLots"
                formikProps={formikProps}
                disabled={buttonWorks.anyWorks}
            />
            <NoticeIntegerInput
                label={`mmia.${reportStep}.numberOfOffers`}
                id="numberOfOffers"
                formikProps={formikProps}
                disabled={buttonWorks.anyWorks}
            />
            <NoticeIntegerInput
                label={`mmia.${reportStep}.numberOfRejectedOffers`}
                id="numberOfRejectedOffers"
                formikProps={formikProps}
                disabled={buttonWorks.anyWorks}
            />
            <NoticeIntegerInput
                label={`mmia.${reportStep}.numberOfOffersSubmittedByMMSP`}
                id="numberOfOffersSubmittedByMMSP"
                formikProps={formikProps}
                disabled={buttonWorks.anyWorks}
            />
            <NoticeYesNoInput
                label={`mmia.${reportStep}.contractAwardedToMMSP`}
                id="contractAwardedToMMSP"
                formikProps={formikProps}
                disabled={buttonWorks.anyWorks}
            />

        </>
    )

}

AnnualReportAboveEuEditForm.propTypes = {
    entry: PropTypes.object.isRequired,
    newEntry: PropTypes.bool,
    buttonWorks: PropTypes.shape({anyWorks: PropTypes.bool.isRequired}).isRequired,
    reportStep: PropTypes.string.isRequired,
    formikProps: PropTypes.object.isRequired
}

export default AnnualReportAboveEuEditForm;